import { doGetRequest } from "./mainAPI";
import { DOCUMENT, USER } from "../constants/mainAPI";
import { FilesSuccessResponse } from "../types/api/files";

export const getFiles = (
    callback?: (resp: FilesSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${USER}/${DOCUMENT}`, true, searchParams, callback, errorCallback);
};
